import React from 'react';
import TimePicker from 'rc-time-picker';
import moment from 'moment';
import './styles/timepicker.scss'

const format = "YYYY-MM-DD HH:mm:ss";

class HC_TimePicker extends React.Component {
    constructor(props) {
        super(props);
    }

    handleChangeValue(value) {
        let startTimeStr = moment().format("YYYY-MM-DD") + value.format(" HH:mm:ss");
        let correctedTime = moment(startTimeStr, format);

        let o = {};
        o.target = {"data-key": this.props.dataKey, "value" : correctedTime.valueOf(), "getAttribute": function (o) {
            return this.props.dataKey;
        }.bind(this)};
        this.props.handleChangeValue(o)
    }

    render() {
        return <TimePicker data-key={this.props.dataKey} className="hc-f4" style={this.props.style} showSecond={false} onChange={this.handleChangeValue.bind(this)}
                           value={this.props.time ? moment(this.props.time) : null }
                           />
    }
}

module.exports = HC_TimePicker;









// WEBPACK FOOTER //
// ./timepicker.js